import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
    CustomIconConstants,
    MenuConstants,
    PubSubConstants
} from '@zlib/config';
import { Menu } from '@zlib/data-access/models/menu.model';
import { AuthService } from '@zlib/services/auth.service';
import { CookieService } from '@zlib/services/cookie.services';
import { PubSubService } from '@zlib/services/pubsub.services';
import { SecurityHelper } from '@zlib/services/security.helper';
import { NzIconModule, NzIconService } from 'ng-zorro-antd/icon';
import { NzSiderComponent } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSliderModule } from 'ng-zorro-antd/slider';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [
        NzMenuModule,
        NzSliderModule,
        TranslateModule,
        NzIconModule,
        NzSiderComponent,
        FormsModule,
        CommonModule
    ]
})
export class SidebarComponent implements OnInit {
    isCollapsed: boolean = false;
    items: Menu[] = [];
    segment = '';
    expandWidth: number = 0;
    select: number = 0;
    urls: any = {};
    activeId: string = '';
    isCollapsedState = true;
    minWidth = 96;
    maxWidth = 236;
    activeRoute = '';

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public securityHelper: SecurityHelper,
        private authService: AuthService,
        private cookieService: CookieService,
        private iconService: NzIconService,
        private pubsub: PubSubService
    ) {
        this.buildCustomIcon();
    }

    buildCustomIcon(): void {
        CustomIconConstants.customIcons.forEach((item) => {
            this.iconService.addIconLiteral(item.name, item.src);
        });
    }

    ngOnInit() {
        this.activeRoute = this.router.url;

        const currentLanguage = this.cookieService.get('lang');
        this.segment = this.router.url.replace(currentLanguage, '');

        const segments = this.segment.split('/').filter((i) => i !== '');

        this.items = MenuConstants.ITEMS;

        this.items.map((item: any) => {
            this.urls[item.url] = item.id;
        });

        const urlCombination = this.urlCombination(segments);
        for (let i = 0; i <= urlCombination.length; i++) {
            const activeId = this.urls[urlCombination[i]];
            if (activeId) {
                this.activeId = activeId;
                break;
            }
        }

        this.setSideBarWidth();
        this.authService.currentSubscriptionsSubject.subscribe({
            next: (subscriptions) => {
                if (!subscriptions?.length) {
                    this.items.forEach((item) => {
                        item.hasPermission = false;
                    });
                } else {
                    this.setPermission(this.items);
                }
            }
        });

        this.pubsub.$sub(PubSubConstants.EVENTS.ON_EXPAND_LEFT_NAV, (data) => {
            this.isCollapsed = data;
            this.setSideBarWidth();
        });
    }

    setSideBarWidth(): void {
        if (this.isCollapsed) {
            this.expandWidth = this.minWidth;
        } else {
            this.expandWidth = this.maxWidth;
        }
    }

    setPermission(items: Menu[]) {
        // TODO: menu only support 2 level
        items.forEach((element) => {
            element.hasPermission =
                !element.permisisons ||
                this.hasOneOfPermission(element.permisisons);
        });
    }

    hasOneOfPermission(permissions: string[]) {
        if (!permissions || permissions.length === 0) {
            return true;
        }
        return this.securityHelper.hasOneOfPermissions(permissions);
    }

    onNavigation(menu: Menu) {
        if (menu && menu.url) {
            this.router.navigate([`/${menu.url}`], {
                relativeTo: this.route
            });
        }
    }

    isActiveSubmenu(menu: Menu): boolean {
        let isActive = false;
        const segments = this.segment
            .split('/')
            .reverse()
            .filter((x) => x != '');
        if (menu && menu.children && menu.children.length) {
            const childSegments = menu.children
                .filter((child) => child.url)
                .map(
                    (child: any) =>
                        child.url.split('/').filter((x) => x != '')[0]
                );

            if (
                childSegments.some((c) => c !== '' && segments.indexOf(c) > -1)
            ) {
                isActive = true;
            }
        }
        return isActive;
    }

    isActiveMenu(menu: Menu): boolean {
        return menu.url === this.activeRoute;
    }

    urlCombination(urls: string[]) {
        const combined: any = [];
        let temp = '';
        urls.forEach((url) => {
            if (temp) {
                combined.push([temp, url].join('/'));
                temp = [temp, url].join('/');
            } else {
                combined.push(url);
                temp = url;
            }
        });
        return combined.reverse();
    }

    onLogout(): void {
        this.authService.logout().subscribe(() => {});
        this.router.navigate(['/auth/login']);
    }
}
